export default "__VITE_ASSET__C8YZRD1E__"